import { SdmMatchConfig } from "../models/site";
import axiosConfig from "./axiosConfig";

const deleteSiteMarketplaceMatch = async (
  authToken: string,
  siteId: string,
  match: SdmMatchConfig
): Promise<void> => {
  const { data } = await axiosConfig.delete(`/site/${siteId}/marketplace`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    data: match,
  });
  return data;
};

export default deleteSiteMarketplaceMatch;
